<template>
  <div>
    <v-sheet color="primary" tile class="white--text text-center">
      <div :style="mobile ? 'height: 60px;' : 'height: 72px;'"></div>
      <p :class="mobile ? 'regular-16' : 'regular-24' + ' mb-1'">MBTI로 소름 좀 돋아본 당신을 위한</p>
      <p :class="mobile ? 'bold-30' : 'bold-50' + ' mb-5'">‘중국어 잠재력 테스트’</p>
      <p :class="mobile ? 'regular-16' : 'regular-24'">중국어로 꿰뚫어 보는 당신의 성향👀</p>
      <div :style="mobile ? 'height: 24px;' : 'height: 32px;'"></div>
      <v-img contain :src="require('../assets/people.svg')" :height="mobile ? 199 : 320"></v-img>
    </v-sheet>

    <v-container :class="mobile ? 'pt-5' : 'pt-12'">
      <v-row justify="center">
        <v-col sm="12" md="6">
          <my-button color="primary" depressed @click="startTest()">테스트 시작 / 10문항</my-button>
          <div :style="mobile ? 'height: 20px;' : 'height: 32px;'"></div>
          <share-container></share-container>
          <div style="height: 80px;"></div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MyButton from "../components/MyButton";
import ShareContainer from "../components/ShareContainer";

export default {
  components: { MyButton, ShareContainer },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    startTest() {
      this.$amplitude.getInstance().logEvent("Button Start Test Clicked");
      this.$router.push("/test");
    }
  },
  created() {
    this.$amplitude.getInstance().logEvent("Page Home Viewed");
  }
};
</script>

<style>
</style>
